module.exports = __webpack_public_path__ + "static/media/security.2e8d5cd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/security.svg
// module id = 299
// module chunks = 0